import '../styles/LandingServiceStatement.css';
import React from 'react';

const CHAIN = [
  { step: 'Handover', num: '01' },
  { step: 'In transit', num: '02' },
  { step: 'Custody verified', num: '03' },
  { step: 'Out for delivery', num: '04' },
  { step: 'Delivered', num: '05' },
];

function LandingServiceStatement() {
  return (
    <section
      className="lss-band"
      id="service-statement"
      aria-labelledby="lss-title"
    >
      <div className="lss-inner">
        <div className="lss-grid">
          <div className="lss-head">
            <p className="lss-eyebrow">
              <span className="lss-eyebrow-mark" aria-hidden="true" />
              What we do
            </p>
            <h2 className="lss-title" id="lss-title">
              Consignment shipments,
              <br />
              tracked end to end
            </h2>
          </div>

          <div className="lss-body">
            <p className="lss-lede">
              <span className="lss-lede-strong">
                Fast Forward Deliver Services
              </span>{' '}
              handles consignment shipments tracked from handover to delivery.
              Every consignment carries its own waybill serial, route, weight
              and timestamp, so its stage is read straight off the record —
              never guessed.
            </p>

            <div className="lss-chain">
              <ol className="lss-chain-list">
                {CHAIN.map((item, index) => (
                  <React.Fragment key={item.step}>
                    {index > 0 && (
                      <li
                        className="lss-chain-sep"
                        aria-hidden="true"
                      >
                        /
                      </li>
                    )}
                    <li className="lss-chain-item">
                      <span className="lss-chain-num">{item.num}</span>
                      <span className="lss-chain-step">{item.step}</span>
                    </li>
                  </React.Fragment>
                ))}
              </ol>
            </div>

            <div className="lss-rule" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LandingServiceStatement;